:host {
  max-height: calc(100vh - 100px);
  overflow: var(--gridStackManager-overflow, auto);
  --vertical-widget-main-container-padding: 24px 24px 16px;
  --horizontal-widget-main-container-padding: 16px;
}

.grid-wrapper {
  margin: var(--grid-margin);
}

.grid-wrapper-show-cells {
  background: var(--white-layout-301-level-0-elevation);
}

.grid-stack-show-cells {
  --color: var(--white-layout-302-level-1-elevation);
  background-image: linear-gradient(to left, transparent calc(100% - var(--grid-half-gutter)), var(--color) 0),
    linear-gradient(to right, transparent calc(100% - var(--grid-half-gutter)), var(--color) 0),
    linear-gradient(to top, transparent calc(100% - var(--grid-half-gutter)), var(--color) 0),
    linear-gradient(to bottom, transparent calc(100% - var(--grid-half-gutter)), var(--color) 0);
  background-size: calc(100% / var(--column-count)) var(--cell-height);
}

.flex-group {
  margin-bottom: 10px;
}

.choose-title {
  margin-bottom: 5px;
}

:host([withoutLoadingAnimations]) {
  --animation: none;
}

gz-input-number {
  margin-bottom: 5px;
  display: inline-block;
}

.grid-stack {
  .grid-stack-item {
    --vertical-widget-main-container-padding: 24px 24px 16px;
    --horizontal-widget-main-container-padding: 16px;

    .grid-stack-item-content {
      border: 1px solid var(--chart-103-pressed);
      border-radius: 4px;
    }
  }
}

.grid-stack .grid-stack-item > .ui-resizable-handle {
  filter: none;
}
.grid-stack {
  position: relative;
}
.grid-stack.grid-stack-rtl {
  direction: ltr;
}
.grid-stack.grid-stack-rtl > .grid-stack-item {
  direction: rtl;
}
.grid-stack .grid-stack-placeholder > .placeholder-content {
  background-color: var(--chart-050-hover);
  margin: 0;
  position: absolute;
  width: auto;
  z-index: 0 !important;
  text-align: center;
}
.grid-stack > .grid-stack-item {
  min-width: 8.3333333333%;
  position: absolute;
  padding: 0;
}
.grid-stack > .grid-stack-item > .grid-stack-item-content {
  margin: 0;
  position: absolute;
  width: auto;
  overflow: hidden;
}
.grid-stack > .grid-stack-item > .ui-resizable-handle {
  position: absolute;
  bottom: calc(var(--spacer) * 2);
  right: calc(var(--spacer) * 2);
  display: block;
  -ms-touch-action: none;
  touch-action: none;
  transition: background-color 0.3s ease 0s, color 0.3s ease 0s;
  border-radius: 4px;

  &:active::before {
    color: var(--main-titles-inputs-600);
  }
  &:hover {
    background-color: var(--chart-050-hover);
  }
}
.grid-stack > .grid-stack-item:hover {
  gz-generic-widget {
    &::part(move-icon),
    &::part(close-button) {
      visibility: visible;
    }
  }
}

.hide-resize-button {
  display: none !important;
}
.grid-stack > .grid-stack-item.ui-resizable-autohide > .ui-resizable-handle,
.grid-stack > .grid-stack-item.ui-resizable-disabled > .ui-resizable-handle {
  display: none;
}
.grid-stack > .grid-stack-item > .ui-resizable-se {
  background-image: none;
  font-family: 'ds-bitdefender' !important;
}
.grid-stack > .grid-stack-item > .ui-resizable-se::before {
  font-family: 'ds-bitdefender' !important;
  content: '\e97b';
  font-size: 24px;
  color: var(--chart-302-icon-buttons-titles);
}
.grid-stack > .grid-stack-item > .ui-resizable-nw {
  cursor: nw-resize;
  width: 20px;
  height: 20px;
  top: 0;
}
.grid-stack > .grid-stack-item > .ui-resizable-n {
  cursor: n-resize;
  height: 10px;
  top: 0;
  left: 25px;
  right: 25px;
}
.grid-stack > .grid-stack-item > .ui-resizable-ne {
  cursor: ne-resize;
  width: 20px;
  height: 20px;
  top: 0;
}
.grid-stack > .grid-stack-item > .ui-resizable-e {
  cursor: e-resize;
  width: 10px;
  top: 15px;
  bottom: 15px;
}
.grid-stack > .grid-stack-item > .ui-resizable-se {
  cursor: se-resize;
  width: 24px;
  height: 24px;
}
.grid-stack > .grid-stack-item > .ui-resizable-s {
  cursor: s-resize;
  height: 10px;
  left: 25px;
  bottom: 0;
  right: 25px;
}
.grid-stack > .grid-stack-item > .ui-resizable-sw {
  cursor: sw-resize;
  width: 20px;
  height: 20px;
}
.grid-stack > .grid-stack-item > .ui-resizable-w {
  cursor: w-resize;
  width: 10px;
  top: 15px;
  bottom: 15px;
}
.grid-stack > .grid-stack-item.ui-draggable-dragging > .ui-resizable-handle {
  display: none !important;
}
.grid-stack > .grid-stack-item[gs-w='0'] {
  width: 0;
}
.grid-stack > .grid-stack-item[gs-x='0'] {
  left: 0;
}
.grid-stack > .grid-stack-item[gs-min-w='0'] {
  min-width: 0;
}
.grid-stack > .grid-stack-item[gs-max-w='0'] {
  max-width: 0;
}
.grid-stack > .grid-stack-item[gs-w='1'] {
  width: 8.3333333333%;
}
.grid-stack > .grid-stack-item[gs-x='1'] {
  left: 8.3333333333%;
}
.grid-stack > .grid-stack-item[gs-min-w='1'] {
  min-width: 8.3333333333%;
}
.grid-stack > .grid-stack-item[gs-max-w='1'] {
  max-width: 8.3333333333%;
}
.grid-stack > .grid-stack-item[gs-w='2'] {
  width: 16.6666666667%;
}
.grid-stack > .grid-stack-item[gs-x='2'] {
  left: 16.6666666667%;
}
.grid-stack > .grid-stack-item[gs-min-w='2'] {
  min-width: 16.6666666667%;
}
.grid-stack > .grid-stack-item[gs-max-w='2'] {
  max-width: 16.6666666667%;
}
.grid-stack > .grid-stack-item[gs-w='3'] {
  width: 25%;
}
.grid-stack > .grid-stack-item[gs-x='3'] {
  left: 25%;
}
.grid-stack > .grid-stack-item[gs-min-w='3'] {
  min-width: 25%;
}
.grid-stack > .grid-stack-item[gs-max-w='3'] {
  max-width: 25%;
}
.grid-stack > .grid-stack-item[gs-w='4'] {
  width: 33.3333333333%;
}
.grid-stack > .grid-stack-item[gs-x='4'] {
  left: 33.3333333333%;
}
.grid-stack > .grid-stack-item[gs-min-w='4'] {
  min-width: 33.3333333333%;
}
.grid-stack > .grid-stack-item[gs-max-w='4'] {
  max-width: 33.3333333333%;
}
.grid-stack > .grid-stack-item[gs-w='5'] {
  width: 41.6666666667%;
}
.grid-stack > .grid-stack-item[gs-x='5'] {
  left: 41.6666666667%;
}
.grid-stack > .grid-stack-item[gs-min-w='5'] {
  min-width: 41.6666666667%;
}
.grid-stack > .grid-stack-item[gs-max-w='5'] {
  max-width: 41.6666666667%;
}
.grid-stack > .grid-stack-item[gs-w='6'] {
  width: 50%;
}
.grid-stack > .grid-stack-item[gs-x='6'] {
  left: 50%;
}
.grid-stack > .grid-stack-item[gs-min-w='6'] {
  min-width: 50%;
}
.grid-stack > .grid-stack-item[gs-max-w='6'] {
  max-width: 50%;
}
.grid-stack > .grid-stack-item[gs-w='7'] {
  width: 58.3333333333%;
}
.grid-stack > .grid-stack-item[gs-x='7'] {
  left: 58.3333333333%;
}
.grid-stack > .grid-stack-item[gs-min-w='7'] {
  min-width: 58.3333333333%;
}
.grid-stack > .grid-stack-item[gs-max-w='7'] {
  max-width: 58.3333333333%;
}
.grid-stack > .grid-stack-item[gs-w='8'] {
  width: 66.6666666667%;
}
.grid-stack > .grid-stack-item[gs-x='8'] {
  left: 66.6666666667%;
}
.grid-stack > .grid-stack-item[gs-min-w='8'] {
  min-width: 66.6666666667%;
}
.grid-stack > .grid-stack-item[gs-max-w='8'] {
  max-width: 66.6666666667%;
}
.grid-stack > .grid-stack-item[gs-w='9'] {
  width: 75%;
}
.grid-stack > .grid-stack-item[gs-x='9'] {
  left: 75%;
}
.grid-stack > .grid-stack-item[gs-min-w='9'] {
  min-width: 75%;
}
.grid-stack > .grid-stack-item[gs-max-w='9'] {
  max-width: 75%;
}
.grid-stack > .grid-stack-item[gs-w='10'] {
  width: 83.3333333333%;
}
.grid-stack > .grid-stack-item[gs-x='10'] {
  left: 83.3333333333%;
}
.grid-stack > .grid-stack-item[gs-min-w='10'] {
  min-width: 83.3333333333%;
}
.grid-stack > .grid-stack-item[gs-max-w='10'] {
  max-width: 83.3333333333%;
}
.grid-stack > .grid-stack-item[gs-w='11'] {
  width: 91.6666666667%;
}
.grid-stack > .grid-stack-item[gs-x='11'] {
  left: 91.6666666667%;
}
.grid-stack > .grid-stack-item[gs-min-w='11'] {
  min-width: 91.6666666667%;
}
.grid-stack > .grid-stack-item[gs-max-w='11'] {
  max-width: 91.6666666667%;
}
.grid-stack > .grid-stack-item[gs-w='12'] {
  width: 100%;
}
.grid-stack > .grid-stack-item[gs-x='12'] {
  left: 100%;
}
.grid-stack > .grid-stack-item[gs-min-w='12'] {
  min-width: 100%;
}
.grid-stack > .grid-stack-item[gs-max-w='12'] {
  max-width: 100%;
}
.grid-stack.grid-stack-1 > .grid-stack-item {
  min-width: 100%;
}
.grid-stack.grid-stack-1 > .grid-stack-item[gs-w='1'] {
  width: 100%;
}
.grid-stack.grid-stack-1 > .grid-stack-item[gs-x='1'] {
  left: 100%;
}
.grid-stack.grid-stack-1 > .grid-stack-item[gs-min-w='1'] {
  min-width: 100%;
}
.grid-stack.grid-stack-1 > .grid-stack-item[gs-max-w='1'] {
  max-width: 100%;
}
.grid-stack.grid-stack-animate,
.grid-stack.grid-stack-animate .grid-stack-item {
  -webkit-transition: left 0.3s, top 0.3s, height 0.3s, width 0.3s;
  -moz-transition: left 0.3s, top 0.3s, height 0.3s, width 0.3s;
  -ms-transition: left 0.3s, top 0.3s, height 0.3s, width 0.3s;
  -o-transition: left 0.3s, top 0.3s, height 0.3s, width 0.3s;
  transition: left 0.3s, top 0.3s, height 0.3s, width 0.3s;
}
.grid-stack.grid-stack-animate .grid-stack-item.grid-stack-placeholder,
.grid-stack.grid-stack-animate .grid-stack-item.ui-draggable-dragging,
.grid-stack.grid-stack-animate .grid-stack-item.ui-resizable-resizing {
  -webkit-transition: left 0s, top 0s, height 0s, width 0s;
  -moz-transition: left 0s, top 0s, height 0s, width 0s;
  -ms-transition: left 0s, top 0s, height 0s, width 0s;
  -o-transition: left 0s, top 0s, height 0s, width 0s;
  transition: left 0s, top 0s, height 0s, width 0s;
}
.ui-draggable-dragging,
.ui-resizable-resizing {
  z-index: 100;
}
.ui-draggable-dragging > .grid-stack-item-content,
.ui-resizable-resizing > .grid-stack-item-content {
  box-shadow: 1px 4px 6px var(--chart-050-hover);
  opacity: 0.8;
}
.ui-draggable-dragging {
  will-change: left, top;
  cursor: move;
}
.ui-resizable-resizing {
  will-change: width, height;
}

:host([displayMode='pdf']) {
  .grid-wrapper {
    margin-top: 0;
  }
  .grid-stack > .grid-stack-item {
    padding: 5px;

    & > .grid-stack-item-content {
      position: relative !important;
      height: 100%;
    }
  }
}
